export const maxKeywordInputLength = 300;
